module.exports = __webpack_public_path__ + "img/search.b417eda5.svg";